import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { Box, Typography } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { LoadStatus } from 'constants/aiProcessRuns';

import { selectMessagesByStep, selectStepMessagesStatus } from 'store/aiProcessRuns';

import CitedText from '../../AiActivityCitations/CitedText';
import {
  messageMetaStyles,
  messageRowStyles,
  transcriptStyles,
} from '../ExecutionDetailDrawer.styles';

import StepMessagesPlaceholder from './StepMessagesPlaceholder';
import { formatMessageContent, formatMessageRole } from './StepTranscript.utils';

const StepTranscript = ({ stepExecutionId }) => {
  const messages = useSelector(selectMessagesByStep(stepExecutionId));
  const messagesStatus = useSelector(selectStepMessagesStatus(stepExecutionId));

  if (_.isEmpty(messages)) {
    if (messagesStatus !== LoadStatus.READY) {
      return <StepMessagesPlaceholder status={messagesStatus} stepExecutionId={stepExecutionId} />;
    }

    return (
      <Box>
        <Typography sx={messageMetaStyles} variant="regular12">
          No messages for this step.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={transcriptStyles}>
      {messages.map(message => {
        const role = formatMessageRole(message);

        return (
          <Box key={message.id} sx={messageRowStyles(role)}>
            <Typography sx={messageMetaStyles} variant="bold12">
              {role}
            </Typography>
            <Typography variant="regular14">
              <CitedText text={formatMessageContent(message)} />
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

StepTranscript.propTypes = {
  stepExecutionId: PropTypes.string.isRequired,
};

export default memo(StepTranscript);
